// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turing-ui-v2-logo{
    font-weight: 500;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    color: #000;
}

.turing-ui-v2-partner-logo {
    max-height: 57px;
    max-width: 107px;
}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/logo/Logo.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".turing-ui-v2-logo{\n    font-weight: 500;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    color: #000;\n}\n\n.turing-ui-v2-partner-logo {\n    max-height: 57px;\n    max-width: 107px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
